var _style, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    viewBox: "0 0 1000 1000",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "SVGID_1_",
    x1: 146.4465,
    x2: 853.5535,
    y1: 853.5535,
    y2: 146.4465
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD521"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05510481,
    style: {
      stopColor: "#FFD020"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1241,
    style: {
      stopColor: "#FEC01E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2004,
    style: {
      stopColor: "#FCA71B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2821,
    style: {
      stopColor: "#FA8316"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3681,
    style: {
      stopColor: "#F85510"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4563,
    style: {
      stopColor: "#F51E09"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#F30005"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5035,
    style: {
      stopColor: "#F20007"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5966,
    style: {
      stopColor: "#E1003B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6879,
    style: {
      stopColor: "#D30067"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7757,
    style: {
      stopColor: "#C70088"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8589,
    style: {
      stopColor: "#BF00A0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9357,
    style: {
      stopColor: "#BB00AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B900B4"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M500,1000L500,1000C223.9,1000,0,776.1,0,500v0C0,223.9,223.9,0,500,0h0c276.1,0,500,223.9,500,500v0  C1000,776.1,776.1,1000,500,1000z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M500,220.2c91.1,0,101.9,0.3,137.9,2c33.3,1.5,51.4,7.1,63.4,11.8c15.9,6.2,27.3,13.6,39.2,25.5   c11.9,11.9,19.3,23.3,25.5,39.2c4.7,12,10.2,30.1,11.8,63.4c1.6,36,2,46.8,2,137.9s-0.3,101.9-2,137.9   c-1.5,33.3-7.1,51.4-11.8,63.4c-6.2,15.9-13.6,27.3-25.5,39.2c-11.9,11.9-23.3,19.3-39.2,25.5c-12,4.7-30.1,10.2-63.4,11.8   c-36,1.6-46.8,2-137.9,2s-101.9-0.3-137.9-2c-33.3-1.5-51.4-7.1-63.4-11.8c-15.9-6.2-27.3-13.6-39.2-25.5   c-11.9-11.9-19.3-23.3-25.5-39.2c-4.7-12-10.2-30.1-11.8-63.4c-1.6-36-2-46.8-2-137.9s0.3-101.9,2-137.9   c1.5-33.3,7.1-51.4,11.8-63.4c6.2-15.9,13.6-27.3,25.5-39.2c11.9-11.9,23.3-19.3,39.2-25.5c12-4.7,30.1-10.2,63.4-11.8   C398.1,220.5,408.9,220.2,500,220.2 M500,158.7c-92.7,0-104.3,0.4-140.7,2.1c-36.3,1.7-61.1,7.4-82.9,15.9   C254,185.3,234.9,197,216,216c-19,19-30.6,38-39.4,60.5c-8.4,21.7-14.2,46.5-15.9,82.9c-1.7,36.4-2.1,48-2.1,140.7   c0,92.7,0.4,104.3,2.1,140.7c1.7,36.3,7.4,61.1,15.9,82.9C185.3,746,197,765.1,216,784c19,19,38,30.6,60.5,39.4   c21.7,8.4,46.5,14.2,82.9,15.9c36.4,1.7,48,2.1,140.7,2.1s104.3-0.4,140.7-2.1c36.3-1.7,61.1-7.4,82.9-15.9   C746,814.7,765.1,803,784,784c19-19,30.6-38,39.4-60.5c8.4-21.7,14.2-46.5,15.9-82.9c1.7-36.4,2.1-48,2.1-140.7   s-0.4-104.3-2.1-140.7c-1.7-36.3-7.4-61.1-15.9-82.9C814.7,254,803,234.9,784,216c-19-19-38-30.6-60.5-39.4   c-21.7-8.4-46.5-14.2-82.9-15.9C604.3,159.1,592.7,158.7,500,158.7L500,158.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M500,324.7c-96.8,0-175.3,78.5-175.3,175.3S403.2,675.3,500,675.3S675.3,596.8,675.3,500   S596.8,324.7,500,324.7z M500,613.8c-62.8,0-113.8-50.9-113.8-113.8S437.2,386.2,500,386.2c62.8,0,113.8,50.9,113.8,113.8   S562.8,613.8,500,613.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 682.2,
    cy: 317.8,
    r: 41
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmInstagram);
export default __webpack_public_path__ + "static/media/sm-instagram.0b3e8a0c68c61f6f9de668820032ea7d.svg";
export { ForwardRef as ReactComponent };